import Box from '@/common/components/Box'
import ResumeItem from '@/common/components/ResumeItem'
import { formatDate, formatDateTime } from '@/common/utils/formatters'
import TransportAutoEntriesDeliveryCode from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/CheckinEntry/Transport/AutoEntries/DeliveryCode'
import { checkinEntryOptions } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/directiveEntryFormSteps/checkinEntry/checkinEntryOptions.constant'
import { useForwardingTabContext } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/useForwardingTabContext'
import { CancelMaintenanceWorkflowForwadingModal } from '../../../../CancelMaintenanceWorkflowFowardingModal'
import useUserPermissions from '@/common/hooks/useUserPermissions'
import { useState } from 'react'
import DropdownMenu from '@/common/components/DropdownMenu'
import { TriangleAlert } from 'lucide-react'

interface MaintenanceWorkflowForwardingCheckinEntrySectionProps {
  showTransportAutoEntriesDeliveryCode?: boolean
}

const MaintenanceWorkflowForwardingCheckinEntrySection = ({
  showTransportAutoEntriesDeliveryCode,
}: MaintenanceWorkflowForwardingCheckinEntrySectionProps) => {
  const [cancelForwardingModalIsOpen, setCancelForwardingModalIsOpen] = useState<boolean>(false)

  const { forwarding, workflow } = useForwardingTabContext();

  const { hasUserPermission, isUserPermissionsPending } = useUserPermissions()
  const userHasPermissionToCancelMaintenanceWorflowForwarding =
    isUserPermissionsPending || hasUserPermission('Client::Maintenance::Forwardings::Cancel')

  const showCancelMaintenanceWorkflowForwardingButton = userHasPermissionToCancelMaintenanceWorflowForwarding 
    && forwarding?.status !== 'canceled' 
    && forwarding?.status !== 'completed'
    && workflow?.status !== 'canceled'
    && workflow?.status !== 'completed'

  return (
    <>
      <Box className="flex items-center justify-between p-4">
        <div className="flex items-center gap-4">
          <ResumeItem
            label="Data de criação"
            value={formatDate(new Date(forwarding.created_at))}
            labelClassName="text-white-400"
            valueClassName="text-md"
          />

          {forwarding.canceled_at && (
            <ResumeItem
            label="Data de cancelamento"
            value={formatDate(new Date(forwarding.canceled_at))}
            labelClassName="text-white-400"
            valueClassName="text-md"
            />
          )}
        </div>

        {showCancelMaintenanceWorkflowForwardingButton && (
          <DropdownMenu
            triggerClassName="bg-primary-blue hover:bg-primary-blue/80 justify-self-end"
            triggerLabel="Ações"
            menuPositionAlign="end"
            options={[
              {
                label: (
                  <p className="flex items-center gap-2 text-danger-soft">
                    <TriangleAlert className="max-w-5" />
                    Cancelar encaminhamento
                  </p>
                ),
                onClick: () => setCancelForwardingModalIsOpen(true),
                operationKlassToCheckPermission: "Admin::Maintenance::Forwardings::Cancel",
              },
            ]}
          />
        )}
      </Box>
      <Box className="p-4 flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <div className="flex flex-col">
            <p className="text-lg font-semibold">Método de check-in</p>

            {forwarding?.checkin_entry?.completed_at && <p className="text-valid text-xs">Check-in concluído</p>}
          </div>

          {showTransportAutoEntriesDeliveryCode && <TransportAutoEntriesDeliveryCode />}
        </div>

        <div className="flex gap-3">
          {forwarding?.checkin_entry_type && (
            <ResumeItem
              label="Responsável por Transporte"
              value={checkinEntryOptions[forwarding.checkin_entry_type].title || '--'}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}

          {forwarding?.checkin_entry?.responsible && (
            <ResumeItem
              label="Responsável por Transporte"
              value={forwarding?.checkin_entry?.responsible.full_name || '--'}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}

          {forwarding?.checkin_entry?.completed_at && (
            <ResumeItem
              label="Check-in realizado"
              value={formatDateTime(new Date(forwarding?.checkin_entry?.completed_at))}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}
        </div>
      </Box>
      <CancelMaintenanceWorkflowForwadingModal
        isOpen={cancelForwardingModalIsOpen}
        setIsOpen={setCancelForwardingModalIsOpen}
        workflowForwadingId={workflow?.current_forwarding?.id}
        workflowId={workflow?.id}
      />
    </>
  )
}

export default MaintenanceWorkflowForwardingCheckinEntrySection
